import { render, staticRenderFns } from "./PromptsList.vue?vue&type=template&id=678b61da&scoped=true&"
import script from "./PromptsList.vue?vue&type=script&lang=js&"
export * from "./PromptsList.vue?vue&type=script&lang=js&"
import style0 from "./PromptsList.vue?vue&type=style&index=0&id=678b61da&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "678b61da",
  null
  
)

export default component.exports